export default __webpack_public_path__ + "4134c4b754df4e2b47fe9c86e460e50d.svg";